import React, { Suspense } from 'react';
import bundleManifest from 'src/bundles_manifest.json';
import config from 'src/shared/config';
import { LoadScripts } from '../../scriptsLoader/loadScripts';
import { LoadProduct } from './loadProduct';
import { LoadSceneData } from './loadSceneData';

const scriptUrls = [
    config.publicPath + 'assets/libs/jquery/jquery-3.1.1.min.js',
    config.publicPath + 'assets/libs/jquery/jquery.mousewheel.js',
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_0'],
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_1'],
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_2'],
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_not_minify']
];

export const LoadPreview3D = ({
    children,
    productId,
    productCode,
    fallback,
    onSceneLoaded
}: {
    children: React.ReactNode;
    fallback: React.ReactNode;
    productId?: string | null;
    productCode?: string | null;
    onSceneLoaded: (isNew: boolean) => void;
}) => {
    return (
        <LoadScripts fallback={fallback} scriptUrls={scriptUrls}>
            <Suspense fallback={fallback}>
                <LoadProduct productId={productId} productCode={productCode}>
                    <LoadSceneData onSceneLoaded={onSceneLoaded}>{children}</LoadSceneData>
                </LoadProduct>
            </Suspense>
        </LoadScripts>
    );
};
